import { random, randomDate, randomName, randomSizeList, randomWord } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts';
import { companyFactory } from '../location/company.factory';
import { journeyPlanFactory } from './journey-plan.factory';
import { Journey } from './journey.model';
import { stopTimeFactory } from './stopTime.factory';

export const journeyFactory = Factory.makeFactory<Journey>({
	deletedDate: Factory.each(() => new Date(randomDate())),
	extId: Factory.each(() => randomWord()),
	journeyPlan: Factory.each(() => journeyPlanFactory.build()),
	name: Factory.each(() => randomName()),
	provider: Factory.each(() => randomName()),
	stopTimes: Factory.each(() =>
		randomSizeList(
			() => stopTimeFactory.build(),
			30,
			() => random(30),
		),
	),
	uuid: Factory.each((i) => i.toString()),
	carrier: Factory.each(() => companyFactory.build()),
});
